<app-dialog-header [title]="'GENERAL.BUTTON.REPLACE_CERTIFICATE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start" class="p-8">
    <app-providers-all-list
        [certificationProvidersTotalCount$]="certificationProvidersTotalCount$"
        [displayedColumns]="displayedColumns"
        [canUserManageCertificates]="false"
        [parentType]="ParentType.Replace"
        [isViewOnly]="true"
        [userId]="userId"
        [certificateToBeReplaced]="certificateToBeReplaced"
        (onSelectCertificate)="onSelectCertificate($event)"
        [sessionStorageListPageSize]="'replaceCertificatesListPageSize'"
    ></app-providers-all-list>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="buttonText | translate" (onClick)="saveSelected()" [disabled]="!selectedCertificate" [isLoading]="isSaveButtonLoading"></app-flat-button>
</div>
